import React, { useEffect } from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";
import { GameImage } from './GameImage.jsx';

export class Game extends React.Component {
    constructor(props) {
        super(props);
    }
   
    createGoogleTagEvent() {
        var kategorijeArray = [];
        if (this.props.categories) {
            Object.keys(this.props.igra.kt).forEach(key => {
                var filterKategorija = this.props.categories.find(x => x.id == key);
                if (filterKategorija)
                    kategorijeArray.push(filterKategorija.name);
            });
            casino.utils.createGoogleTagManagerEvent({
                'event': 'game_click',
                'game_name': this.props.igra.n,
                'game_provider': this.props.brands[this.props.igra.bID].name,
                'game_type': kategorijeArray ? kategorijeArray.join() : '',
                'jackpot': this.props.igra.jp ? 'yes' : 'no',
                'jackpot_amount': this.props.igra.jp ? this.props.igra.jp : 0,
                'gameId': this.props.igra.id
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.SearchValue !== nextProps.SearchValue ||
            this.props.FilterValue !== nextProps.FilterValue ||
            this.props.igra.id !== nextProps.igra.id
        )
    }

    render() {
        var game = this.props.igra;    
        var brand = this.props.brands[game.bID];
        var isRive = false;
        let riveSrc = "";
        let artboard = "";

        if (game && game.s && (game.s === "EVOLUTION_primatekingmegaways_primatekingmegaw" || game.s === "Spinomenal-SlotMachine_JadranskoMore" || game.s === "EVOLUTION_stockmarket_StockMarket00002" || game.s === "EVOLUTION_hrvatskoblagomegaways_hrvatskoblagomeg" || game.s === "EASIT-BookOfHrvatska_Mobile" || game.s === "EVOLUTION_monopolybigballer_MonBigBaller0001" || game.s === "EVOLUTION_gonzotreasuremap_GonzoTM000000001" || game.s === "EVOLUTION_balloonrace_BalloonRace00001" || game.s === "EVOLUTION_roulette_LightningTable01" || game.s === "PLAYSON-scharged_clovers" || game.s === "PLAYSON-royal_coins_2" || game.s === "Octoplay-break-the-piggy-bank")) {
            if (game.s === "EVOLUTION_primatekingmegaways_primatekingmegaw") {
                riveSrc = "Content/Rive/thumb_red_tiger_primate_king_620x500.riv";
                artboard = "Artboard"
                isRive = true;
            } else if (game.s === "EVOLUTION_stockmarket_StockMarket00002") {
                riveSrc = "Content/Rive/thumb_stockmarket_620x500_v2.riv";
                artboard = "Artboard"
                isRive = true;
            } else if (game.s === "EASIT-BookOfHrvatska_Mobile") {
                riveSrc = "Content/Rive/thumb_easit_book-of-hrvatska_620x500.riv";
                artboard = "Artboard"
                isRive = true;
            } else if (game.s === "EVOLUTION_monopolybigballer_MonBigBaller0001") {
                riveSrc = "Content/Rive/thumb_evolution_monopolybigballer_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "EVOLUTION_gonzotreasuremap_GonzoTM000000001") {
                riveSrc = "Content/Rive/thumb_evolution_gonzostreasuremap_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "EVOLUTION_balloonrace_BalloonRace00001") {
                riveSrc = "Content/Rive/thumb_evolution_balloonrace_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "EVOLUTION_roulette_LightningTable01") {
                riveSrc = "Content/Rive/thumb_evolution_lightningroulette_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "PLAYSON-scharged_clovers") {
                riveSrc = "Content/Rive/thumb_playson_superchargedclover_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "PLAYSON-royal_coins_2") {
                riveSrc = "Content/Rive/thumb_playson_royalcoins_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "EVOLUTION_hrvatskoblagomegaways_hrvatskoblagomeg") {
                riveSrc = "Content/Rive/thumb_hrvatskoblago_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "Spinomenal-SlotMachine_JadranskoMore") {
                riveSrc = "Content/Rive/thumb_jadranskomore_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            } else if (game.s === "Octoplay-break-the-piggy-bank") {
                riveSrc = "Content/Rive/thumb_octoplay_breakthepiggybank_620x500.riv";
                isRive = true;
                artboard = "Artboard";
            }
        }

        let maintenanceClass = this.props.igra && this.props.igra.p && (this.props.igra.p.indexOf("o") !== -1) ? 'maintenance ' : '';

        if (this.props.fromNative) {
            let link = "";
            if (this.props.fromNativeGameName) {
                link = `supersport://casino/games/${this.props.igra.s}`;
            } else {
                link = `https://mcasino.supersport.hr/game/${brand.nameNormalizirano}/${casino.utils.normalizeString(this.props.igra.n)}`;
            }
            return (
                
                <a href={link}
                    onClick={() => this.createGoogleTagEvent()}
                    id={"game-" + this.props.igra.id}
                    className={'game-item ' + maintenanceClass + (this.props.extraClass || '')}>

                    <GameImage
                        igra={this.props.igra}
                        brands={this.props.brands}
                        showJackpot={this.props.showJackpot}
                        routePrefix={this.props.routePrefix}
                        goLazyImage={this.props.goLazyImage}
                        isRive={isRive}
                        riveSrc={riveSrc}
                        artboard={artboard}
                        isVerticalImage={this.props.isVerticalImage}
                    />

                    <div className="relative">
                        {this.props.showJackpot && this.props.igra.jp && <div className="game-jackpot"></div>}
                        <span className={'game-name ' + (this.props.gameNameClass || '')}>{this.props.igra.n}</span>
                    </div>
                </a>
            )
        } else {
            return (

                <NavLink
                    onClick={() => this.createGoogleTagEvent()}
                    to={{
                        pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[this.props.igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(this.props.igra.n),
                        query: {
                            game: casino.utils.normalizeString(this.props.igra.n),
                            from: (this.props.from || ''),
                            // GamePosition podaci, HizmanB
                            PageName: this.props.PageName,
                            GamePosition: this.props.GamePosition,
                            PositionType: this.props.PositionType,
                            ComponentName: this.props.ComponentName,
                            ComponentPosition: this.props.ComponentPosition,
                            IsIcon: this.props.IsIcon,
                            TabName: this.props.TabName,
                            TabPosition: this.props.TabPosition,
                            SliderName: this.props.SliderName,
                            SliderPosition: this.props.SliderPosition,
                            SearchValue: this.props.SearchValue,
                            FilterValue: this.props.FilterValue
                        }
                    }}
                    id={"game-" + this.props.igra.id}
                    className={'game-item ' + maintenanceClass + (this.props.extraClass || '')}>

                    <GameImage
                        igra={this.props.igra}
                        brands={this.props.brands}
                        showJackpot={this.props.showJackpot}
                        routePrefix={this.props.routePrefix}
                        goLazyImage={this.props.goLazyImage}
                        categories={this.props.categories}
                        isRive={isRive}
                        riveSrc={riveSrc}
                        artboard={artboard}
                        isVerticalImage={this.props.isVerticalImage}
                    />
                    <div className="relative">
                        {this.props.showJackpot && this.props.igra.jp && <div className="game-jackpot"></div>}
                        <span className={'game-name ' + (this.props.gameNameClass || '')}>{this.props.igra.n}</span>
                    </div>
                </NavLink>
            );
        }
    }
};
